export const getStyles = () => ({
  missionContainer: {
    background:
      "linear-gradient(to top, #E1E1FF 0%, #E1E1FF 40%, rgba(225, 225, 255, 0.8) 60%, rgba(225, 225, 255, 0.4) 80%, transparent 100%)",
  },
  missionSection: {
    display: "grid",
    position: "relative",
    paddingBlock: "32px",
    gap: "40px",

    "@media (min-width: 960px)": {
      gridColumn: "2 / -2",
      gridTemplateColumns: "repeat(2, 50%)",
      gap: 0,
    },
  },
  missionImage: {
    justifySelf: "center",

    "& img": {
      objectFit: "contain",
      width: "100%",
      maxWidth: "200px",
    },
    "@media (min-width: 960px)": {
      alignSelf: "center",
      gridColumn: "1 / 2",

      "& img": {
        objectFit: "contain",
        width: "100%",
        maxWidth: "500px",
      },
    },
  },
  missionDescription: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",

    "& h2": {
      fontSize: "1.25rem",
      marginBottom: "24px",
    },
    "& p": {
      fontSize: "0.875rem",
      marginBottom: "16px",
    },
    "@media (min-width: 960px)": {
      gridColumn: "2 / 3",
      paddingBlock: "72px",
      gap: "40px",
      paddingLeft: "40px",

      "& h2": {
        fontSize: "2.5rem",
        marginBottom: "0",
      },

      "& p": {
        fontSize: "1.5rem",
      },
    },
  },

  button: {
    "&.MuiButton-containedInfo": {
      backgroundColor: "#fff",
      color: "#222",
    },
  },
});
